import { useState,useContext,useEffect } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
// import PerfectScrollbar from 'react-perfect-scrollbar'
import {
   // Avatar,
   Box,
   Card,
   Checkbox,
   Table,
   TableBody,
   TableCell,
   TableHead,
   TablePagination,
   TableRow,
   Typography,
   Switch
} from '@material-ui/core'
// import getInitials from '../../utils/getInitials'
import { Link } from 'react-router-dom'
import { postPublicAPI, getPublicAPI } from '../../api'
import { ShoppingCartContext } from '../../contexts/ShoppingCart'

const CustomerListResults = ({ users, ...rest }) => {
   const [customers, setCustomers] = useState(users)
   const { searchCustomer } = useContext(ShoppingCartContext)
   const [selectedCustomerIds, setSelectedCustomerIds] = useState([])
   const [limit, setLimit] = useState(10)
   const [page, setPage] = useState(0)

   
   useEffect(() => {
      setCustomers(users)
   }, [searchCustomer,users])

   const handleSelectAll = event => {
      let newSelectedCustomerIds

      if (event.target.checked) {
         newSelectedCustomerIds = customers.map(customer => customer.id)
      } else {
         newSelectedCustomerIds = []
      }

      setSelectedCustomerIds(newSelectedCustomerIds)
   }

   const handleSelectOne = (event, id) => {
      const selectedIndex = selectedCustomerIds.indexOf(id)
      let newSelectedCustomerIds = []

      if (selectedIndex === -1) {
         newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedCustomerIds, id)
      } else if (selectedIndex === 0) {
         newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedCustomerIds.slice(1))
      } else if (selectedIndex === selectedCustomerIds.length - 1) {
         newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedCustomerIds.slice(0, -1))
      } else if (selectedIndex > 0) {
         newSelectedCustomerIds = newSelectedCustomerIds.concat(
            selectedCustomerIds.slice(0, selectedIndex),
            selectedCustomerIds.slice(selectedIndex + 1)
         )
      }

      setSelectedCustomerIds(newSelectedCustomerIds)
   }

   const handleLimitChange = event => {
      setLimit(event.target.value)
   }

   const handlePageChange = (event, newPage) => {
      setPage(newPage)
   }

   const handleChange = async (customerId, value) => {
      const updated = await postPublicAPI('/update-customer-status', { value, customerId })
      if (updated?.success) {
         let allUsers = await getPublicAPI(`/users`)
         if (allUsers?.success) {
            setCustomers(allUsers.data)
         }
      }
   }

   return (
      <Card {...rest}>
         {/* <PerfectScrollbar> */}
         <Box sx={{ minWidth: 1050 }}>
            <Table>
               <TableHead>
                  <TableRow>
                     <TableCell padding='checkbox'>
                        <Checkbox
                           checked={selectedCustomerIds.length === customers.length}
                           color='primary'
                           indeterminate={
                              selectedCustomerIds.length > 0 &&
                              selectedCustomerIds.length < customers.length
                           }
                           onChange={handleSelectAll}
                        />
                     </TableCell>
                     {/* <TableCell>Image</TableCell> */}
                     <TableCell>Name</TableCell>
                     <TableCell>Email</TableCell>
                     <TableCell>Location</TableCell>
                     <TableCell>Phone</TableCell>
                     <TableCell>Registration date</TableCell>
                     <TableCell>Status</TableCell>
                     <TableCell>Enable/Disable Login</TableCell>
                  </TableRow>
               </TableHead>
               <TableBody>
                  {customers.slice(0, limit).map(customer => {
                     return (
                        <TableRow
                           hover
                           key={customer._id}
                           selected={selectedCustomerIds.indexOf(customer._id) !== -1}
                        >
                           <TableCell
                              padding='checkbox'
                              component={Link}
                              to={{ pathname: `profile/${customer._id}` }}
                           >
                              <Checkbox
                                 checked={selectedCustomerIds.indexOf(customer._id) !== -1}
                                 onChange={event => handleSelectOne(event, customer._id)}
                                 value='true'
                              />
                           </TableCell>
                           <TableCell component={Link} to={{ pathname: `profile/${customer._id}` }}>
                              <Box
                                 sx={{
                                    alignItems: 'center',
                                    display: 'flex'
                                 }}
                              >
                                 {/* <Avatar src={customer.avatarUrl} sx={{ mr: 2 }}>
                                    {getInitials(customer.fname)} {getInitials(customer.lname)}
                                 </Avatar> */}
                                 <Typography color='textPrimary' variant='body1'>
                                    {customer.fName} {customer.lName}
                                 </Typography>
                              </Box>
                           </TableCell>
                           <TableCell component={Link} to={{ pathname: `profile/${customer._id}` }}>
                              {customer.email}
                           </TableCell>
                           <TableCell component={Link} to={{ pathname: `profile/${customer._id}` }}>
                              Not available
                           </TableCell>
                           <TableCell component={Link} to={{ pathname: `profile/${customer._id}` }}>
                              {customer.phone}
                           </TableCell>
                           <TableCell>{moment(customer.createdAt).format('DD/MM/YYYY')}</TableCell>
                           {customer.status === 'Active' ? (
                              <TableCell style={{ color: '#09ad2a' }}>{customer.status}</TableCell>
                           ) : (
                              <TableCell style={{ color: '#628761' }}>{customer.status}</TableCell>
                           )}
                           <TableCell>
                              <Switch
                                 checked={customer.isLoginAllowed ? true : false}
                                 onChange={() => {
                                    handleChange(
                                       customer._id,
                                       customer.isLoginAllowed ? false : true
                                    )
                                 }}
                                 name={'isChecked' + customer._id}
                                 inputProps={{ 'aria-label': 'secondary checkbox' }}
                              />
                           </TableCell>
                        </TableRow>
                     )
                  })}
               </TableBody>
            </Table>
         </Box>
         {/* </PerfectScrollbar> */}
         <TablePagination
            component='div'
            count={customers.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5, 10, 25]}
         />
      </Card>
   )
}

CustomerListResults.propTypes = {
   users: PropTypes.array.isRequired
}

export default CustomerListResults